import { INTENT_TYPE } from '../../constants';
import { getOpenSpan } from '../features/navigation-target';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `S-AMBIGUOUS-OPEN` (priority 875) — `open …` with nothing concrete to open.
 *
 * `open` is the one cue that can plausibly begin a navigation, a Chat request, or a
 * page title, so it gets an explicit resting place instead of being left to the
 * catch-all. `open the mystery box` names no navigable artefact, so `S-NAVIGATE`
 * declined it; a rule that says so is worth more in telemetry than a silent
 * `NO_MATCH`, because the reason distribution here is exactly what tells us whether
 * the artefact lexicon needs another member.
 *
 * "No complete Chat grammar matched" is guaranteed structurally rather than checked:
 * first match wins, so reaching priority 875 at all means every Chat rule above
 * already declined.
 */
export const isAmbiguousOpen = (features: FeatureContext): boolean =>
	getOpenSpan(features.qMatch) !== null && !features.navigationTarget;

export const ambiguousOpenRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	pattern: 'AMBIGUOUS_OPEN',
	matches: isAmbiguousOpen,
};
